// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3unX5","errors":"Errors_errors__1dYKR"};